// Mock data for the digital wedding invitation. Later, RSVP + guestbook will be backed by the API.

export const couple = {
  names: "Adam & Sara",
  initials: "A&S",
  fullNames: "Adam & Sara",
  dateLabel: "12.09.2026",
  // ISO date for countdown (Sept 12, 2026, 15:00 local)
  weddingISO: "2026-09-12T15:00:00",
  locationShort: "Lake Como, Italy",
  tagline: "The wedding of",
};

export const heroImages = {
  left: "https://images.unsplash.com/photo-1540076156429-35ffe82b7870?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxyb21hbnRpYyUyMGNvdXBsZXxlbnwwfHx8fDE3ODYxMjc3MzV8MA&ixlib=rb-4.1.0&q=85",
  right: "https://images.unsplash.com/photo-1615966650071-855b15f29ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxyb21hbnRpYyUyMGNvdXBsZXxlbnwwfHx8fDE3ODYxMjc3MzV8MA&ixlib=rb-4.1.0&q=85",
};

export const intro = {
  heading: "We\u2019re getting married! And we\u2019d love for you to join us on our special day.",
  body: "We\u2019re heading to the shores of Lake Como for a two-day celebration in Bellagio. You\u2019ll find everything here \u2014 from the plans and location to travel details and RSVP. See you this September!",
};

export const ourStory = {
  title: "Our Story",
  lead: "It all started with a chance meeting on a rooftop in Milan that neither of us expected.",
  paragraphs: [
    "What began as a simple introduction quickly turned into something more. From our first conversations to the moments we\u2019ve shared since, we\u2019ve grown together in ways we never expected. Each moment brought us closer and created the foundation of what we have today.",
    "Through every high and low, we\u2019ve stood side by side, learning and growing together. Now, we\u2019re so excited to celebrate the start of our next chapter with all of you.",
  ],
  imgMain: "https://images.unsplash.com/photo-1615966650071-855b15f29ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxyb21hbnRpYyUyMGNvdXBsZXxlbnwwfHx8fDE3ODYxMjc3MzV8MA&ixlib=rb-4.1.0&q=85",
  imgOverlay: "https://images.unsplash.com/photo-1597682496035-b04f723202a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxJdGFsaWFuJTIwdmlsbGF8ZW58MHx8fHwxNzg2MTI3OTI3fDA&ixlib=rb-4.1.0&q=85",
};

export const venue = {
  name: "Villa del Lago",
  description: "Our wedding venue is a breathtaking 18th-century villa on the shores of Lake Como, set among terraced gardens, cypress trees and sweeping water views. It\u2019s the perfect setting for our celebration.",
  address: ["Villa del Lago", "Via Regina 40", "22021 Bellagio (CO)", "Italy"],
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Bellagio+Lake+Como",
  time: "15:00",
  date: "12th September 2026",
  transport: "Water taxis can be arranged from Como and Bellagio.",
  image: "https://images.unsplash.com/photo-1586974726316-c6302de6a160?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxMYWtlJTIwQ29tb3xlbnwwfHx8fDE3ODYxMjc4NzF8MA&ixlib=rb-4.1.0&q=85",
};

export const itinerary = {
  title: "The Weekend Itinerary",
  dayOne: {
    dateLabel: "Saturday, September 12th",
    title: "Wedding Day",
    image: "https://images.unsplash.com/photo-1523438885200-e635ba2c371e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwY2VyZW1vbnl8ZW58MHx8fHwxNzg2MTI3ODcwfDA&ixlib=rb-4.1.0&q=85",
    events: [
      { time: "15:00", name: "Arrival", text: "Upon arrival at the villa on Lake Como, you\u2019ll be welcomed with prosecco and light bites on the terrace." },
      { time: "16:30", name: "Ceremony", text: "Take your seats by the water as we exchange our vows and celebrate the start of our next chapter together." },
      { time: "18:30", name: "Reception", text: "Join us in the lakeside gardens for dinner, dancing and drinks as we celebrate long into the evening." },
    ],
  },
  dayTwo: {
    dateLabel: "Sunday, September 13th",
    title: "The After-party",
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwb29sfGVufDB8fHx8MTc4NjEyNzg3MHww&ixlib=rb-4.1.0&q=85",
    events: [
      { time: "12:00", name: "Welcome Drinks", text: "Join us by the pool for relaxed drinks and good company as we ease into the day together." },
      { time: "13:15", name: "Lakeside Lunch", text: "Enjoy a laid-back poolside lunch with fresh Italian food, music and plenty of time to unwind." },
      { time: "15:00", name: "Afternoon Drinks", text: "Spend the afternoon by the water with more drinks, music and time to relax before we say goodbye." },
    ],
  },
};

export const travel = {
  title: "Getting to Our Wedding",
  options: [
    { mode: "By Plane", text: "The closest international airport is **Milan Malpensa (MXP)**, located approximately a 90 minute drive to the wedding venue in Bellagio.", mapUrl: "https://www.google.com/maps/search/?api=1&query=Milan+Malpensa+Airport" },
    { mode: "By Train", text: "The train station closest to the wedding is **Como San Giovanni**, with regular connections from Milan and across northern Italy.", mapUrl: "https://www.google.com/maps/search/?api=1&query=Como+San+Giovanni+station" },
    { mode: "By Car", text: "The venue is easily reached via the **SS340 lakeside road**, with valet parking available on-site. Bellagio is around 90 minutes from Milan.", mapUrl: "https://www.google.com/maps/search/?api=1&query=Bellagio+Lake+Como" },
  ],
  image: "https://images.unsplash.com/photo-1664433451451-11337deef597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxMYWtlJTIwQ29tb3xlbnwwfHx8fDE3ODYxMjc4NzF8MA&ixlib=rb-4.1.0&q=85",
};

export const stay = {
  title: "Where to Stay",
  intro: "We\u2019ve picked a handful of our favourite hotels and villas that are within easy reach of the venue. Make sure to book early as September is a busy season on Lake Como.",
  image: "https://images.unsplash.com/photo-1597682496035-b04f723202a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxJdGFsaWFuJTIwdmlsbGF8ZW58MHx8fHwxNzg2MTI3OTI3fDA&ixlib=rb-4.1.0&q=85",
  hotels: [
    { name: "Grand Hotel Tremezzo", note: "8 min drive from venue", url: "https://www.booking.com/" },
    { name: "Hotel Belvedere Bellagio", note: "4 min walk from venue", url: "https://www.booking.com/" },
  ],
  otherUrl: "https://www.booking.com/",
};

export const registry = {
  kicker: "Wedding Gift Registry",
  heading: "Having you join us at our wedding is already more than we could ask for.",
  body: "If you would like to contribute, we\u2019ve put together a small registry or you can add to our honeymoon fund.",
  registryUrl: "https://www.amazon.com/wedding",
  honeymoonUrl: "https://www.honeyfund.com/",
  image: "https://images.unsplash.com/photo-1654011905292-c342dd9fc433?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxMYWtlJTIwQ29tb3xlbnwwfHx8fDE3ODYxMjc4NzF8MA&ixlib=rb-4.1.0&q=85",
};

export const gallery = {
  title: "Moments",
  subtitle: "A few of our favourite memories together on the road to forever.",
  images: [
    "https://images.unsplash.com/photo-1540076156429-35ffe82b7870?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxyb21hbnRpYyUyMGNvdXBsZXxlbnwwfHx8fDE3ODYxMjc3MzV8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1537633552985-df8429e8048b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxkZXN0aW5hdGlvbiUyMHdlZGRpbmd8ZW58MHx8fHwxNzg2MTI3NzM1fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1614929511547-974944a54c92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxlbmdhZ2VtZW50JTIwcGhvdG9zaG9vdHxlbnwwfHx8fDE3ODYxMjc3MzZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1530227222086-4037fdd5e723?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjB3YWxraW5nfGVufDB8fHx8MTc4NjEyNzc0OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/flagged/photo-1579369772188-7aa75cd44c57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxlbmdhZ2VtZW50JTIwcGhvdG9zaG9vdHxlbnwwfHx8fDE3ODYxMjc3MzZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1572376985751-4bb67485b5fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxjb3VwbGUlMjB3YWxraW5nfGVufDB8fHx8MTc4NjEyNzc0OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1598976701972-40f0bf429d9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxlbmdhZ2VtZW50JTIwcGhvdG9zaG9vdHxlbnwwfHx8fDE3ODYxMjc3MzZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1590170413412-0d31bb651c8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxjb3VwbGUlMjB3YWxraW5nfGVufDB8fHx8MTc4NjEyNzc0OXww&ixlib=rb-4.1.0&q=85",
  ],
};

export const faqs = [
  { q: "What is the dress code?", a: "We kindly ask guests to dress formal for the celebration, keeping the warm September weather in mind. Lightweight fabrics and comfortable footwear are recommended." },
  { q: "How do I get to the venue?", a: "The venue is located in Bellagio on Lake Como. You can find full travel details above, including directions by plane, train, car and water taxi." },
  { q: "Is there parking available?", a: "Yes, valet parking is available on-site at the villa for guests arriving by car." },
  { q: "Can I bring a plus one?", a: "If your invitation includes a plus one, their name will be listed on your invite. Please include them when completing your RSVP." },
  { q: "Are children invited?", a: "While we love your little ones, this will be an adults-only celebration unless otherwise specified on your invitation." },
  { q: "Who should I contact if I have questions?", a: "If you have any questions, feel free to reach out to us directly at hello@adamandsara.com \u2014 we\u2019re happy to help." },
];

export const rsvpMeta = {
  title: "We\u2019ll See You There",
  body: "Please let us know if you\u2019ll be joining us for our wedding. Kindly RSVP below and share any details we may need.",
  image: "https://images.unsplash.com/photo-1533800790978-ab520ae73a68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxnYXJkZW4lMjBzdGF0dWV8ZW58MHx8fHwxNzg2MTI3OTI3fDA&ixlib=rb-4.1.0&q=85",
  meals: ["No preference", "Vegetarian", "Vegan", "Pescatarian", "Gluten-Free"],
};

export const navLinks = [
  { label: "Our Story", href: "#story" },
  { label: "Location", href: "#location" },
  { label: "Schedule", href: "#schedule" },
  { label: "Travel & Stay", href: "#travel" },
  { label: "Gallery", href: "#gallery" },
];
